import { PatentListData } from "@/components/business/PatentContainer/Patent.types";
import { useGetCurrentEntryData } from "@hooks/useGetCurrentEntryData";

import { useMovePatentDetailPage } from "../components/PatentTitleContainer/components/PatentTableShellForPatentTitle/hooks/useMovePatentDetailPage";

/**
 * 행 단위 공용 네비게이션 훅.
 * Title / Applicant 등 "클릭 시 디테일 페이지 이동"이 필요한 셀이 공유한다.
 * status 변경 알림 모달 없이 바로 진입하며, 클릭 핸들러(clickToMove)를 반환한다.
 */
export const usePatentRowNavigation = (patentListItem: PatentListData) => {
  const draftArticleId = patentListItem?.draftArticleId?.toString();
  const getEntryData = useGetCurrentEntryData(draftArticleId);

  const { movePatentDetailPage } = useMovePatentDetailPage({
    draftArticleId,
    publicationNumber: patentListItem?.publicationNumber,
  });

  const clickToMove = () => {
    getEntryData();
    sessionStorage.setItem("scrollPosition", window.scrollY.toString());
    movePatentDetailPage();
  };

  return { clickToMove };
};
